const initialState = {};

export default (state = initialState, action) => {
    switch(action.type) {
        case 'SET_COMPANY':
            return {
                ...action.company
            };
        default:
            return state;
    }
};